<template>
  <div class="bg">
    <top-nav title="下载中心"></top-nav>
    <div class="cec-info">
        <img class="absolute-img" src="@/assets/images/cec2022/bird_2.png" style="z-index:-1"/>
        <div class="buttons">
            <div class="flex">
                <img src="@/assets/images/cec2022/down_btn1.png" @click="skip(1)" />
                <img src="@/assets/images/cec2022/down_btn2.png" @click="skip(2)"/>
            </div>
            <div class="flex">
				<img src="@/assets/images/cec2022/down_btn5.png" @click="skip(3)"/>
                <!-- <img src="@/assets/images/cec2022/down_btn3.png"  @click="skip(3)"/> -->
                <img src="@/assets/images/cec2022/down_btn4.png" @click="skip(4)"/>
            </div>
            <div class="flex">
				<img src="@/assets/images/cec2022/down_btn10.png" @click="skip(7)"/>
                <img src="@/assets/images/cec2022/down_btn8.png" @click="skip(5)"/>
			</div>
			<div class="flex">
                <img src="@/assets/images/cec2022/down_btn9.png" @click="skip(6)"/>
                <img src="@/assets/images/cec2022/down_btn11.png" @click="skip(8)"/>
            </div>
			<div class="flex">
                <img src="@/assets/images/cec2022/down_btn12.png" @click="skip(9)"/>
            </div>
        </div>
    </div>
    <img src="@/assets/images/cec2022/bottom_img.png" class="bottom-img"/>
  </div>
</template>

<script>
import topNav from "./component/topNav.vue" 
import {ButtonDetail} from '../../config/interface.js'

export default {
    components:{
        topNav
    },
    created(){
        this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
        this.getButtonData();
    },
     methods:{
            //获取按钮信息
			getButtonData(){
				if(this.button_id){
					const url=ButtonDetail;
					let params={
                    	button_id:this.button_id
					}
					const method="POST";
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							document.title=res.data.share_title;
							if(common.is_weixin()){
								let data=res.data;
								common.wxShare(data.share_title,data.share_sub_title,data.share_img);
							}
						}
					})

				}
			},
			skip(type){
				switch(type){
					case 1:
						this.$router.push('/cec2022/ppt?meeting_id=286&button_id=937')
						break;
					case 2:
						this.$router.push('/cec2022/invite?meeting_id=286')
						break;
					case 3:
						this.$router.push('/cec2022/zoom?meeting_id=286')
						break;
					case 4:
						window.location.href="https://book.yunzhan365.com/noiry/nnnd/mobile/index.html"
						break;
					case 5:
						this.$router.push('/cec2022/use_zoom')
						break;
					case 6:
						this.$router.push('/cec2022/virtual')
						break;
					case 7:
						window.location.href="https://book.yunzhan365.com/noiry/hwka/mobile/index.html"
						break;
					case 8:
						this.$router.push('/cec2022/schedule_poster')
						break;
					case 9:
						this.$router.push('/cec2022/app_download')
						break;
					
				}
        	},
    }
}
</script>

<style scoped>
.bg{
    background: white;
}
.cec-info{
	padding: 10px 15%;
	position: relative;
}
.cec-info img{
	width: 100%;
}
.cec-info .absolute-img{
	position: absolute;
	top:100px;
	left: 0;
}
.cec-info .red-text{
	color: #B2312E;
}
.cec-info .text{
	margin: 10px 0 30px;
	font-size: 13px;
	line-height: 26px;
}
.cec-info .line1{
	line-height: 40px;
}
.cec-info .line1 img{
	width: 20px;
	vertical-align: middle;
	line-height: 40px;
	margin-right: 10px;
}
.cec-info  .buttons{
	margin: 2rem 0 1rem;
}
.buttons .flex{
	width: 100%;
	display: flex;
	justify-content: space-between;
	margin: 20px 0;
}
.buttons .flex img{
	width: 43%;
}
.wel-text{
	background-color: #C23231;
	color: white;
	font-size: 13px;
	line-height: 30px;
}
.speaker-words{
	position: relative;
	font-size: 13px;
}
.speaker-words .bottom-icon{
	position: absolute;
	right: 0;
	width: 40px;
}
.text-flex{
	margin: 30px 0 20px;
}
.text-flex img{
	width: 29%;
	float: left;
	margin-right: 10px;
}
.bottom-img{
    width: 100%;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/pages/cec2022/download.vue